import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
// import Button from "components/CustomButtons/Button.js";
import FileUpload from "components/FileUpload/FileUploadSanction";
import { useDispatch, useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import brandTheme from "brandTheme/Theme";
import { FormControlLabel, Grid, Switch } from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import axios from "axios";
import { saveAadharTransaction } from "store/reducers/LoanApplication/LoanApplicationSlice";
import ToastModal from "views/components/ToastModal";
import { removeSpecialCharFileName } from "utils/Utils";
import { headerLabel } from "assets/properties/properties";
import ConfirmationModal from "views/components/ConfirmationModal";

const SanctionLetterPartB = ({
  setNext,
  setBack,
  loanApplicationId,
  classes,
  setIsEsign,
  isEsign,
  alreadyEsigned,
  setAlreadyEsigned,
  esingDisable,
  setEsignDisable,
  featureFlags
}) => {
  const params = useParams();
  const dispatch = useDispatch();
  let fileUploadComponent = useRef();
  const [record, setRecord] = useState({});
  const [preview, setPreView] = useState("");
  const [previewsigned, setPreviewsigned] = useState("");
  const [imagefile, setImagefile] = useState("");
  const [screenshotCheque, setScreenshotCheque] = useState(null);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const { authToken } = useSelector((state) => state.login.authData);
  const [backFlex, setBackFlex] = useState(false);
  const [senctionPreview, setSanctionPreview]= useState('')
  const [callInProgress, setCallInProgress] = useState(false);
  const [disableGenerate, setDisableGenerate]= useState(false);
  const [htmlData,setHtmlData]=useState("");
  const [showLinkedLoanBranchFlag, setEsignPartB] = useState(false);
  const [confirmationModal1, setConfirmationModal1] = useState(false);
  const [confirmationModalHeader1, setConfirmationModalHeader1] = useState("");
  const [generateLetter, setGenerateLetter]=useState(false)
  const [sanctionletterLoaderMessage, setSanctionLetterLoaderMessage]=useState("")
  const [confirmationModalMsg1, setConfirmationModalMsg1] = useState("");
  const [optionUpload, setOptionOnlyUpload]= useState(false);

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    GetSanctionLetterDetails();
  }, []);
    useEffect(()=>{
      if(screenshotCheque !== null){
      const localUrl = URL.createObjectURL(screenshotCheque);
      setSanctionPreview(localUrl); 
      setPreView(localUrl)
      }
    },[screenshotCheque])
  
  useEffect(() => {
    getFeatureFlag();
  }, []);
  const getFeatureFlag = async () => {
    const result = await apiHandler({
      url: endpoint.FEATURE_FLAG,
    });
    parseAndSetFlag(result?.data?.esignPartBFlag, setEsignPartB);
    setSanctionLetterLoaderMessage(result?.data?.sanctionLetterLoaderMessage)

  };
  const parseAndSetFlag = (flag, setStateFunction) => {
    const parsedFlag = typeof flag === "boolean" ? flag : flag === "true";
    setStateFunction(parsedFlag);
  };
  const GetSanctionLetterDetails = async () => {
    setCallInProgress(true)
    const loanAccountNumber = loanApplicationId
    const res = await apiHandler({
      url: endpoint.FIND_DOUMENTS + loanAccountNumber,
      method: "GET",
      authToken: authToken,
    })
    setCallInProgress(false)
    if (res?.data?.esignSanctionLetterPartB) {
      setSanctionPreview(res?.data?.esignSanctionLetterPartB);
      setEsignDisable(true)
      setIsEsign(true)
    }else if(res?.data?.sanctionLetterPartBLink && res?.data?.sanctionLetterPartBLink?.includes("esigned")) {
      setIsEsign(true)
      setSanctionPreview(res?.data?.sanctionLetterPartBLink);
      setEsignDisable(true)
    }else if (res?.data?.sanctionLetterPartBLink) {
      setOptionOnlyUpload(true);
      setSanctionPreview(res?.data?.sanctionLetterPartBLink);
    }else if(res?.data?.preSanctionLetterLinkPartB){
      setSanctionPreview(res?.data?.preSanctionLetterLinkPartB);
     }
  };
  const decode = (str) => {
    // add another escaped slash if the string ends with an odd
    // number of escaped slashes which will crash JSON.parse
    let parsedStr = str.replace(/[{}]/g, '');

    // escape unescaped double quotes to prevent error with
    // added double quotes in json string
    parsedStr = parsedStr.replace(/(^|[^\\])((\\\\)*")/g, "$1\\$2");

    try {
      parsedStr = JSON.parse(`"${parsedStr}"`);
    } catch (e) {
      return str;
    }
    return parsedStr;
  };
  const GenerateSanctionLetter = async () => {
    setCallInProgress(true)
    setGenerateLetter(true)
    //SANCTION_LETTER
    const res = await apiHandler({
      url: endpoint.SANCTION_LETTER_CREATE_PART_B + loanApplicationId + "/part-b",
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false)
    setGenerateLetter(false)
    if(res?.data?.error_code){
      toastUpdate("Error", res?.data?.user_description, true);
    }else{
      if (res?.data?.fileLink) {
        setPreView(res?.data?.fileLink)
      }
    }
  };
   const handleProceedUpload=()=>{
        setConfirmationModalHeader1("Preview");
    setConfirmationModalMsg1("Preview uploaded sanction letter");
    setConfirmationModal1(true);
  }
    const handleNegativeUploadResponse = () => {
    setConfirmationModal1(false);
    setConfirmationModalHeader1("");
    setConfirmationModalMsg1("");
  };
    const handlePositiveUploadResponse = async () => {
    handleNegativeUploadResponse();
    // Call API to delete loanMarking
    handleUpload();
  };

  const handleUpload = async () => {
    if (imagefile) {
        UpdateSanctionLetterPartB(imagefile);
    } else {
      if (screenshotCheque || htmlData) {
        setCallInProgress(true);
        const formData = new FormData();
        const fileName = removeSpecialCharFileName(screenshotCheque.name);
        formData.append("file", screenshotCheque, fileName);
        const path = await apiHandler({
          url: endpoint.FILE_UPLOAD,
          method: "POST",
          authToken: authToken,
          data: formData,
        });
        setCallInProgress(false);
        const uploadedPath = path.data;
        UpdateSanctionLetterPartB(uploadedPath.name);
      } else {
        toastUpdate("Error","Upload Signed Sanction letter Before Submited", true);
        ;
      }
    }
    // setNext(); // kamal
  };
  const UpdateSanctionLetterPartB = async (filename) => {
    setCallInProgress(true)
    //SANCTIONLETTER_UPDATE
    const res = await apiHandler({
      url: endpoint.ADMIN_DOCUMENT_UPDATELINKS,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
        sanctionLetterPartBLink: filename,
      },
    });
    setCallInProgress(false)
    //this.setState({ callInProgress: false });
    if (res?.data?.error_code && res?.data?.error_code === 403) {
      toastUpdate("Error", res?.data?.user_description, true);
      return;
    } else if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return;
    } else {
      toastUpdate("Success", "Update sanction Letter successfully", true);
      setBackFlex(true);
      setNext();
    }

    //  props.navigate(`/admin/document/` + params.loanApplicationId);
  };
  useEffect(()=>{
    if (preview && isEsign) {
      getEsignLetter();
    }
  },[preview])
  const getEsignLetter=async()=>{
    setCallInProgress(true)
    //SANCTIONLETTER_UPDATE
    const res = await apiHandler({
      url: endpoint.ESIGN_SANCTION_LETTER + loanApplicationId + "/part-b",
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false)
    if(res?.data?.error_code){
      toastUpdate("Error", res?.data?.user_description, true);
    }
    else {
      if(res?.data?.status === "DONE" && res?.data?.fileLink || res?.data?.status === "PENDING" || res?.data?.status === "INPROCESS"){
        setEsignDisable(true)
        if(res?.data?.fileLink?.includes("esigned") || res?.data?.status === "PENDING"){
          setIsEsign(true)
        }
      }
    }
  }
  const handleEsign=async()=>{
    setCallInProgress(true)
    //SANCTIONLETTER_UPDATE
    const res = await apiHandler({
      url: endpoint.ESIGN_SANCTION_LETTER + loanApplicationId + "/part-b",
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false)
    if(res?.data?.error_code){
      toastUpdate("Error", res?.data?.user_description, true);
    }
    else {
      openHtmlInNewTab(res?.data);
      setNext();
    }
  }
    const openHtmlInNewTab = (htmlResponse) => {
      const blob = new Blob([htmlResponse], { type: 'text/html' });
      const url = URL.createObjectURL(blob);
      setHtmlData(url)
      window.open(url);

    };
    const handleEsignNext = () =>{
      if(!esingDisable && showLinkedLoanBranchFlag){
        toastUpdate("Error","Please Esign the Document", true);

      } else{
        setNext()
      }
  
    }
    const handlecanceluser = () => {
        setBack();
        //props.history.go(-1);
      };
      const handleSwitchChange = async () =>{
        setIsEsign(!isEsign);
      }
  return (
    // <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
             <SubHeader
                    label={headerLabel?.sanctionLetterPartB}
                    subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
                    onlyLabel/>
        </Grid>
      <GridContainer style={{ marginTop: 40 }}>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <GridContainer>
    {!preview ? 
    <>
     <GridItem
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: "center" }}
            >
              <Button onClick={() => GenerateSanctionLetter()} className={classes.nextButton} disabled={disableGenerate}>Generate</Button>
              {senctionPreview && <Button className={classes.nextButton1} onClick={()=> setPreView(senctionPreview)}>Preview</Button>}
       </GridItem>
     </>
 : 
 <>
 {showLinkedLoanBranchFlag &&
  <GridItem
                  xs={12}
                  sm={12}
                  md={8}
                  lg={8}
                  style={{ textAlign: "start" }}
                >
                  <label
                    style={{
                      text: "bold",
                      marginRight: "10px",
                      color: "black",
                    }}
                  >
                    Do you want to Esign with Aadhar{" "}
                  </label>
                  <label style={{ marginRight: "15px", color: "black" }}>
                    No
                  </label>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={isEsign}
                        onChange={handleSwitchChange}
                        name="checkedB"
                        color="primary"
                        disabled={esingDisable || optionUpload}
                      />
                    }
                  />
                  <label style={{ color: "black" }}>Yes</label>
                </GridItem>
    }
  {!esingDisable &&
  <>
          {isEsign  && showLinkedLoanBranchFlag  ? 
           (<GridItem xs={12} sm={12} md={4} lg={4} style={{ textAlign: "end" }}>
           <Button
             size="small"
             className={classes.nextButton}
             onClick={handleEsign}
           >
             Esign
           </Button>
         </GridItem>
       ) : (
         <GridItem
         xs={12}
         sm={12}
         md={12}
         lg={12}
         style={{ textAlign: "end" }}
       >
           <FileUpload
             // avatar={imagefile ? imagefile : DefaultCheque}
             supportedMimeType={["application/pdf"]}
             addButtonProps={{
               color: brandTheme.buttonColor,
               round: false,
             }}
             changeButtonProps={{
               color: brandTheme.buttonColor,
               round: false,
             }}
             removeButtonProps={{
               color: "danger",
               round: false,
             }}
             sendFile={(file) => {
               setScreenshotCheque(file);
               setImagefile("");
             }}
             disabledButton={htmlData}
             ref={fileUploadComponent}
             classes={classes}
             buttonTitle={optionUpload ? "Change" : "Upload"}
             lettername="sanction_Letter"
             optionUpload={optionUpload}
           />
         </GridItem>)
            }
            </>
          }
            <GridItem xs={12} sm={12} md={12} lg={12}>
              {preview !== "" ? (
                <iframe src={preview?preview:senctionPreview} width="100%" height="500px" />
              ) : (
                <div>Downloading Sanction Document</div>
              )}
            </GridItem>
            </>
           }
          </GridContainer>
          <GridContainer>
            <GridItem
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{textAlign: window.innerWidth < 360 ? "center" : "right", }}
            >
             <Button
                  size="small"
                  className={classes.nextButton1}
                  onClick={() => handlecanceluser()}
                >
                  Back
                </Button>
                {preview &&
              <Button
                // style={{ margin: "5px" }}
                size="small"
                // color="info"
                className={classes.nextButton}
                disabled={callInProgress}
                onClick={(event) => (esingDisable || (optionUpload && !screenshotCheque)) ? handleEsignNext() : handleProceedUpload()}
                >
                  Next
              </Button>
              }
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} text={generateLetter ?  sanctionletterLoaderMessage : "Processing..."} />}
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
                   {confirmationModal1 && (
                <ConfirmationModal
                  confirmationModal={confirmationModal1}
                  confirmationModalHeader={confirmationModalHeader1}
                  confirmationModalMsg={confirmationModalMsg1}
                  handleNegativeButton={handleNegativeUploadResponse}
                  handlePositiveButton={handlePositiveUploadResponse}
                />
              )}
        </Grid>
  );
};

SanctionLetterPartB.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
};

export default SanctionLetterPartB;